<template>
  <div class="container-tile is-slider">
    <carousel
      :perPage="1"
      :paginationPadding="0"
      paginationColor="#cccccc"
      paginationActiveColor="black"
      :speed="150"
    >
      <slide v-for="i in slides" :key="i">
        <slot :name="i"></slot>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
export default {
  components: {
    Carousel,
    Slide
  },
  props: ['slides']
}
</script>
